import { Component, Input, OnInit } from '@angular/core';
import {  ISummaryByAdvisor } from '@signal/asp-data-commons';

@Component({
  selector: 'app-day-schedule-card',
  templateUrl: './day-schedule-card.component.html',
  styleUrls: ['./day-schedule-card.component.scss']
})
export class DayScheduleCardComponent implements OnInit {

  @Input() advisorSummary: ISummaryByAdvisor;
  @Input() department: string;
  
  constructor() { }

  ngOnInit(): void {
  
  }

}
